import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/person-management/person-audit',
      name: 'admin-person-audit',
      component: () => import(/* webpackChunkName: "page-admin-person-management-person-audit" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "商务代理审核"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "商务代理管理"
                                        },
                                        {
                                                  name: "商务代理审核"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
